export enum HttpStatus{
    Error = 500
}